import {createSlice} from "@reduxjs/toolkit";

/**
 * navigation 전역 상태 초기값
 * - sideNavState : 사이드 네비게이션 활성화 여부
 */
const initialState = {
    sideNavState: false,
}

/**
 * navigation Redux Slice
 * - 사이드 네비게이션 상태 관리
 */
const navigationSlice = createSlice({
    name: "navigation",
    initialState,
    reducers: {
        /**
         * 사이드 네비게이션 상태 변경
         * @param {Object} state - 현재 state
         * @param {Object} action - Redux action 객체
         */
        sideNavControl(state, action){
            state.sideNavState = action.payload;
        },
    },
});

export const {sideNavControl} = navigationSlice.actions;
export default navigationSlice.reducer;